/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type PersonPaginatedProperty =
  typeof PersonPaginatedProperty[keyof typeof PersonPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PersonPaginatedProperty = {
  CREATED_AT: 'CREATED_AT',
} as const;
